import { Flex, logger, Text } from '@talos/kyoko';
import { useEffect } from 'react';
import type { ManualRFQPricingPanelConfig } from '../../../../types/LayoutConfig';
import { Panel } from '../../../Layout/Components/Panel';
import { ManualRFQPricingPanelContent } from '../../../OMS/ManualRFQPricing/Panel/ManualRFQPricingPanelContent';
import type { LayoutPanelProps } from '../../types';

export function ManualRFQPricingPanel({ api, params }: LayoutPanelProps<ManualRFQPricingPanelConfig>) {
  useEffect(() => {
    if (!params.rfqID) {
      logger.error(new Error('User navigated to ManualRFQPricingPanel without an RFQID'));
    }
  }, [params.rfqID]);

  return (
    <Panel panelApi={api} data-testid="manual-rfq-pricing-panel">
      {/* RFQID should always be defined. This is just a ts thing. */}
      {params.rfqID ? (
        /* Make sure to mount a brand new instance of the content for each RFQID to init and cleanup correctly between RFQIDs. */
        <ManualRFQPricingPanelContent key={params.rfqID} rfqID={params.rfqID} />
      ) : (
        <Flex alignItems="center" justifyContent="center" h="100%">
          <Text>No RFQID found in Panel. Please remove the panel and try again.</Text>
        </Flex>
      )}
    </Panel>
  );
}
